// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"e61eaec7","582":"56bb6d0d","722":"b3667021","748":"858b49e7","778":"c74cafac","882":"f2663c3b","986":"203bb60e"}[chunkId] + ".chunk.js";
};